import {
    FETCH_BRAND_LIST,
    RESET_BRAND_LIST,
  } from "../../constants/action.constants";
  
  const initialState = {
    list: [],
    others: {},
  };
  
  const brandListReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_BRAND_LIST:
        return { list: action.payload, others: action.others };
      case RESET_BRAND_LIST: {
        return initialState;
      }
      default:
        return state;
    }
  };
  
  export default brandListReducer;
  